module.exports = __webpack_public_path__ + "img/41_9.f9765ed9.png";